import { createSlice } from "@reduxjs/toolkit";


export const idSpotLocSlice = createSlice({
    name: 'idSpotLoc',
    initialState:{},
    reducers: { //modify the selected spot in global state
        setIdSpotLoc: (currentState, action) => {
            
            return action.payload //action.payload is the new spot id sent by the dispatch call

        }
    }
});